<template>
    <div
        class="w-full rounded-2xl border border-theme-border bg-theme-card p-5 flex flex-col gap-5"
    >
        <div class="flex flex-wrap items-start justify-between gap-3">
            <div class="flex flex-col gap-1">
                <p
                    class="text-xs font-semibold uppercase tracking-wide text-theme-muted"
                >
                    Plan actual
                </p>
                <p class="text-2xl font-bold text-theme-base">
                    {{ current.planName }}
                </p>
                <p class="text-sm text-theme-muted">
                    {{ typeLabel }} · desde el
                    {{ current.currentPeriodStart | date }}
                </p>
            </div>
            <subscription-status-badge :status="current.status" large />
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <div
                v-for="stat in stats"
                :key="stat.label"
                class="rounded-xl bg-theme-canvas p-4 flex flex-col gap-1"
            >
                <p class="text-xs text-theme-muted">{{ stat.label }}</p>
                <p class="text-base font-semibold text-theme-base">
                    {{ stat.value }}
                </p>
                <p v-if="stat.hint" class="text-xs text-theme-muted">
                    {{ stat.hint }}
                </p>
            </div>
        </div>

        <div v-if="$slots.default" class="flex flex-col gap-3">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import SubscriptionStatusBadge from "@/components/utils/SubscriptionStatusBadge.vue";

const DAY_MS = 24 * 60 * 60 * 1000;

const TYPE_LABELS = {
    trial: "Prueba",
    paid: "Pago",
    free: "Free"
};

export default {
    name: "PlatformSubscriptionCard",
    components: { SubscriptionStatusBadge },
    props: {
        current: {
            type: Object,
            required: true
        },
        scheduled: {
            type: Object,
            default: null
        },
        pendingChange: {
            type: Object,
            default: null
        },
        // `[{ days, byUserId, at }]` de la fila vigente; solo la vista del
        // super las tiene.
        extensions: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        typeLabel() {
            return TYPE_LABELS[this.current.type] || this.current.type;
        },
        stats() {
            const formatDate = this.$options.filters.date;
            const stats = [
                {
                    label:
                        this.current.type === "trial"
                            ? "Fin de la prueba"
                            : "Corte",
                    value: this.current.currentPeriodEnd
                        ? formatDate(this.current.currentPeriodEnd)
                        : "Sin corte",
                    hint: this.remainingLabel(this.current.currentPeriodEnd)
                }
            ];
            if (this.current.gracePeriodEnd) {
                stats.push({
                    label: "Gracia hasta",
                    value: formatDate(this.current.gracePeriodEnd),
                    hint: "Sin pago, pasa a Free"
                });
            }
            if (this.scheduled) {
                stats.push({
                    label: "Cambio programado",
                    value: this.scheduled.planName,
                    hint: `Desde el ${formatDate(
                        this.scheduled.startsAt
                    )} · pagado`
                });
            }
            if (this.pendingChange) {
                stats.push({
                    label: "Cambio pendiente",
                    value: this.pendingChange.planName,
                    hint: `Desde el ${formatDate(this.pendingChange.startsAt)}`
                });
            }
            if (this.extensions.length) {
                const totalDays = this.extensions.reduce(
                    (sum, extension) => sum + extension.days,
                    0
                );
                stats.push({
                    label: "Extensiones",
                    value: `+${totalDays} días`,
                    hint: `${this.extensions.length} ${
                        this.extensions.length === 1
                            ? "extensión"
                            : "extensiones"
                    }`
                });
            }
            return stats;
        }
    },
    methods: {
        remainingLabel(isoDate) {
            if (!isoDate) return "";
            const days = Math.ceil(
                (new Date(isoDate).getTime() - Date.now()) / DAY_MS
            );
            if (days > 1) return `Faltan ${days} días`;
            if (days === 1) return "Falta 1 día";
            if (days === 0) return "Hoy";
            return `Venció hace ${Math.abs(days)} días`;
        }
    }
};
</script>
